module.exports = __webpack_public_path__ + "img/zjct2.6c4e9ba0.jpg";